import { render, staticRenderFns } from "./productSourcingRequest.vue?vue&type=template&id=58266ae2&"
import script from "./productSourcingRequest.vue?vue&type=script&lang=js&"
export * from "./productSourcingRequest.vue?vue&type=script&lang=js&"
import style0 from "./productSourcingRequest.vue?vue&type=style&index=0&id=58266ae2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports